// Local Storage
export const LAST_COMPANY_SELECTED = 'lastCompanySelected'
export const LOCALE = 'locale'
export const HOME_SIDEBAR = 'homeSidebar'
export const LAST_ACCESSED_VERSION_GROUP_PATH_PREFERENCE = 'lastAccessedVersionGroupPathPreference'
export const ROWS_PER_PAGE_PREFERENCE = 'rowsPerPagePreference'
export const LOGS_ROWS_PER_PAGE_PREFERENCE = 'logsRowsPerPagePreference'
export const SELECTED_THEME = 'selectedTheme'
export const SELECTED_CODE_LAYOUT = 'selectedCodeLayout'
export const SAML_COMPANY_SELECTED = 'samlCompanySelected'
export const ANALYSIS_REPORT = 'analysisReport'
export const TASKS_MANAGER_VIEW = 'tasksManagerView'
export const FOLLOW_AGENT = 'followAgent'

// Session Storage
export const INSTANCE_ID = 'instanceId'
export const REDIRECT_TOKEN = 'rtk'
export const DIRECT_ACCESS_COMPANY_CODE = 'directAccessCompanyCode'
export const DIRECT_ACCESS_PENDING = 'directAccessPending'
export const SAML_PENDING_REDIRECT = 'samlPendingRedirect'
export const SAML_CALLBACK_PROCESSING = 'samlCallbackProcessing'
export const NEW_MESSAGES_HINT = 'newMessagesHint'
export const CHUNK_LOAD_ERROR_RELOADED_BUILD = 'chunkLoadErrorReloadedBuild'
export const UI_EXPERIENCE_OVERRIDE = 'uiExperienceOverride'
